export default "__VITE_ASSET__BZ1y$0GA__"